import React, {useState} from 'react';
import {
   View,
   TouchableOpacity,
   Image,
   Text,
   Platform,
   PlatformColor,
} from 'react-native';
import {
   white,
   FONT_FAMILY_REGULAR,
   QrBarcodeSignIn,
   secure_checkout,
   USER_PROFILE,
   BACK_ARROW_HOVER_TINT_COLOR,
   isMacOS,
} from './utils';
import UISvg from '../components/svg';
import {useSelector} from 'react-redux';
import {selectScreenOrientation} from '../redux/slices/ScreenOrientationSlice';
import {BackArrowLink} from '../components/common';
import {StatusBar} from 'react-native';
import {useSafeAreaInsets} from 'react-native-safe-area-context';

export const ApplicationHeader = props => {
   const [isBackArrowHover, setBackArrowHover] = useState(false);
   const isLandscapemode = useSelector(selectScreenOrientation);
   const insets = useSafeAreaInsets();
   const statusBarHeight = insets.top;
   return (
      <View
         style={{
            backgroundColor: '#003DA6',
            width: '100%',
            height:
               Platform.OS === 'web' ||
               Platform.OS === 'windows' ||
               Platform.OS === 'macos'
                  ? 64
                  : Platform.OS === 'ios'
                  ? statusBarHeight + 48
                  : 90,
         }}>
         <UISvg
            height={'100%'}
            width={Platform.OS === 'web' ? '100%' : '200%'}
            x1="0%"
            y1="0%"
            x2="0%"
            y2="100%"
            offset={['0%', '100%']}
            stopColor={['#001F53', '#001F53']}
            stopOpacity={['0', '1']}
            rectWidth={'100%'}
            rectHeight={isMacOS ? 64 : '100%'}
         />
         <View
            style={{
               flexDirection: 'row',
               alignItems: 'center',
               flex: 1,
               marginTop:
                  Platform.OS === 'ios'
                     ? statusBarHeight
                     : Platform.OS === 'android'
                     ? StatusBar.currentHeight
                     : 0,
               justifyContent: isLandscapemode ? 'space-between' : 'flex-start',
               marginStart: 10,
            }}>
            <View
               style={{
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent:
                     props.title === undefined ? 'space-between' : 'flex-start',
                  marginEnd: 10,
                  flex: 1,
               }}>
               {typeof props.OnBackPress !== 'undefined' ? (
                  <BackArrowLink
                     onPress={() => {
                        props.OnBackPress();
                     }}
                  />
               ) : (
                  <TouchableOpacity
                     style={{padding: 10}}
                     onPress={() => {
                        // if (typeof onDrawbarPress !== 'undefined')
                        props.onDrawbarPress();
                     }}>
                     <Image
                        source={require('../assets/hamburger.png')}
                        style={{width: 24, height: 24}}
                     />
                  </TouchableOpacity>
               )}

               {typeof props.title !== 'undefined' ? (
                  <Text
                     style={{
                        fontSize: 16,
                        fontWeight: isLandscapemode ? '500' : '700',
                        fontFamily: FONT_FAMILY_REGULAR,
                        color: 'white',
                        marginStart: 21,
                        top: 0,
                     }}>
                     {props.title}
                  </Text>
               ) : (
                  <Image
                     source={require('../assets/my_logo_header.png')}
                     style={{
                        width: 42,
                        height: 42,
                        resizeMode: 'contain',
                        marginStart: 10,
                     }}
                  />
               )}
            </View>
            <View>
               {typeof props.onSearchPress !== 'undefined' ? (
                  <TouchableOpacity
                     style={{padding: 10}}
                     onPress={() => {
                        if (typeof props.onSearchPress !== 'undefined') {
                           props.onSearchPress();
                        }
                     }}>
                     <Image
                        source={require('../assets/search.png')}
                        style={{width: 18, height: 18, marginRight: 20}}
                     />
                  </TouchableOpacity>
               ) : typeof props.isProfileEnable !== 'undefined' ? (
                  <View style={{flexDirection: 'row'}}>
                     <TouchableOpacity
                        style={{padding: 5}}
                        onPress={() => {
                           props.onEditPress();
                        }}>
                        <Image
                           source={require('../assets/edit.png')}
                           style={{width: 24, height: 24, marginRight: 8}}
                        />
                     </TouchableOpacity>
                     <TouchableOpacity
                        style={{padding: 5}}
                        onPress={() => {
                           // if (typeof onLogOutPress !== 'undefined')
                           props.onLogOutPress();
                        }}>
                        <Image
                           source={require('../assets/logout_white.png')}
                           style={{
                              width: 24,
                              height: 24,
                              marginRight: 20,
                              tintColor: white,
                           }}
                        />
                     </TouchableOpacity>
                  </View>
               ) : (
                  <></>
               )}
            </View>
            {(props.title === QrBarcodeSignIn ||
               (props.title === secure_checkout && isLandscapemode) ||
               props.title === USER_PROFILE) && (
               <Image
                  source={require('../assets/my_logo_header.png')}
                  style={{
                     width: 70,
                     height: 40,
                     resizeMode: 'contain',
                     marginStart: 21,
                  }}
               />
            )}
         </View>
      </View>
   );
};
